import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';

import { AuthClient } from 'api/base';
import { $bonusAccountTransactions } from 'domains/profile';
import { useLinks } from 'hooks/router';

import { Content } from './components';

import style from './style.module.css';

const BonusPage = ({ open }: { open: boolean }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [showInfo, setShowInfo] = React.useState(false);
  const [transactions] = useUnit([$bonusAccountTransactions]);

  const { authLink } = useLinks();

  React.useEffect(() => {
    if (AuthClient.isAuth === false) {
      navigate(authLink, { replace: true });
    }
  }, [authLink, navigate]);

  const handleBackClick = () => {
    if (showInfo) {
      setShowInfo(false);
      return;
    }

    navigate(-1);
  };

  if (!open) {
    return null;
  }

  return (
    <div className={style.root}>
      {/* <div className={style.header}>
        <button
          type='button'
          className='button-arrowBack'
          onClick={handleBackClick}
        />

        <h1 className={style.title}>{t('bonus.page.title')}</h1>
      </div> */}

      <Content
        transactions={transactions}
        showInfo={showInfo}
        onChangeShowInfo={setShowInfo}
      />
    </div>
  );
};

export default BonusPage;